import { render, staticRenderFns } from "./LineItems.vue?vue&type=template&id=a3754c5a&scoped=true"
import script from "./LineItems.vue?vue&type=script&lang=js"
export * from "./LineItems.vue?vue&type=script&lang=js"
import style0 from "./LineItems.vue?vue&type=style&index=0&id=a3754c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3754c5a",
  null
  
)

export default component.exports